module.exports = __webpack_public_path__ + "static/media/rtpose_cover.8af21047.jpg";